<template>
  <van-tabbar route fixed active-color="#ff6600" class="app-footer">
    <van-tabbar-item
      replace
      to="/"
      icon="home-o"
    >
      微官网
    </van-tabbar-item>
    <van-tabbar-item
      replace
      to="/shop"
      icon="flag-o"
    >
      活动
    </van-tabbar-item>
    <van-tabbar-item
      replace
      to="/kp"
      icon="browsing-history-o"
    >
      科普
    </van-tabbar-item>
    <van-tabbar-item
      replace
      to="/user"
      icon="user-circle-o"
    >
      我的
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  name: 'AppFooter',
  props: [],
  methods: {
  }
}
</script>

<style lang="less" scoped>
.app-footer.van-tabbar {
  .fixedapp();
}
.app-footer /deep/ .van-tabbar-item {
  .fontsize(.9rem);
  .van-tabbar-item__icon {
    .fontsize(1.4rem);
  }
}
</style>